// extracted by mini-css-extract-plugin
export default {"bg":"waiting_bg__TshM1","panel":"waiting_panel__fz-pe"};